// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__23bsF","inputWrap":"CustomTip_inputWrap__3dXRJ"};